import protoRoot from "../proto-root";

const name = "getDetectionZonesPreviewRpcRequest";

function create() {
  const GetDetectionZonesPreviewRPCRequest = protoRoot.lookupType("comm.GetDetectionZonesPreviewRPCRequest");
  const request = GetDetectionZonesPreviewRPCRequest.create();
  return { payload: request, name };
}

const getDetectionZonesPreviewRpcRequest = { create, name };

export default getDetectionZonesPreviewRpcRequest;
